module.exports = __webpack_public_path__ + "img/logo-cloudflare.1e6b0e02.jpg";